import * as React from "react";
import * as R from "ramda";
import {Form} from "react-final-form";
import {Col, Row} from "react-bootstrap";
import TipoIdentificacion from "../../../general/componentes/TipoIdentificacion";
import NumericInput from "../../../general/componentes/NumericInput";
import TipoCliente from "../../../general/componentes/TipoCliente";
import {connect} from "react-redux";
import {consultarAfiliacion} from "../../modulos/documentosActions";
import {REQUEST} from "../../../../config/ajax-wrapper";
import {Afiliacion, FiltroRecepcionDocumental} from "../../modelo/Documento";
import {Mensaje} from "../../../general/componentes/Mensaje";
import {DotLoader} from "react-spinners";
import InformacionBasicaRecepcion from "./InformacionBasicaRecepcion";
import TablaRecepcion from "./TablaRecepcion";
import {Oficina} from "../../../general/modelo/Oficina";
import { Alert } from 'react-bootstrap';


class RecepcionDocumental extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = { };
    }
    render() {
        const {afiliaciones,  estado, oficinas, paginas, tamanoPagina, paginaActual} = this.props;
        return (
            <div>
                <Row>
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({handleSubmit, invalid, errors, form, submitting, pristine, values}) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Recepción Documental</h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Buscar Afiliación</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className="form-group">
                                            <Col sm={3}>
                                                <label htmlFor="tipoDocumento">Tipo Documento</label>
                                                <TipoIdentificacion name="tipoDocumento"/>
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="documento">Documento</label>
                                                <NumericInput name="documento" placeholder="Ingrese un documento"/>
                                            </Col>
                                            <Col sm={3}>
                                                <label>Tipo Cliente</label>
                                                <TipoCliente name="tipoCliente" excluir={["PS","DE","OI"]}/>
                                            </Col>
                                        </Row>
                                        <Row className="form-group">
                                            <Col smOffset={7} sm={1}>
                                                <button type="button" className="btns btns-link" onClick={form.reset}
                                                        disabled={submitting || pristine}>
                                                    Limpiar
                                                </button>
                                            </Col>
                                            <Col sm={1}>
                                                <button type="submit" className="btns btns-primary"
                                                        disabled={submitting || invalid}>
                                                    Consultar
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderAfiliaciones(afiliaciones, oficinas, estado,paginas,tamanoPagina,paginaActual)}
                </Row>
            </div>
        );
    }

    renderAfiliaciones(afiliaciones: Array<Afiliacion>, oficinas: Array<Oficina>, estado: REQUEST,paginas: number, tamanoPagina: number, paginaActual: number) {
        switch (estado) {
            case REQUEST.ERROR:
                return  (
                    <Alert color="danger">
                    El pre-registro de esta afiliación fue realizado hace más de tres meses, por lo tanto se debe realizar nuevamente el proceso de afiliación por la página www.arlsura.com.
                    </Alert>
                );
            case REQUEST.PENDING:
                return <DotLoader size={25}/>;
            case REQUEST.SUCCESS:
                const mensajeUsuario = !this.props.mensajeUsuario ? "" : (
                    <Mensaje type={this.props.mensajeUsuario.type}
                             mensaje={this.props.mensajeUsuario.text}/>
                );

                if (this.props.mensajeUsuario) {
                    return (
                        <span>
                            {mensajeUsuario}
                        </span>
                    );
                }

                if (!afiliaciones || afiliaciones.length === 0 ) {
                    return (
                        <span>
                            <Mensaje type={"danger"} mensaje={"No hemos encontrado afiliaciones :("}/>
                        </span>
                    );
                } else {
                    return (
                        <span>
                            {afiliaciones.length === 1 ?
                                <InformacionBasicaRecepcion oficinas={oficinas} afiliacion={afiliaciones[0]}/> :
                                <TablaRecepcion afiliaciones={afiliaciones}
                                filtroDocumento={this.filtros()}
                                consultaPaginada={this.consultaPaginada}
                                paginas={paginas} 
                                tamanoPagina={tamanoPagina}
                                paginaActual={paginaActual} 
                                />}
                        </span>
                    );
                }
            default:
                return false;
        }
    }

    validate = values => {
        const errors = {documento: undefined, tipoDocumento: undefined};

        if (values.tipoDocumento && !values.documento) {
            errors.documento = "Por favor ingrese un documento";
        }

        if ((!values.tipoDocumento || values.tipoDocumento === "Selecciona...") && values.documento) {
            errors.tipoDocumento = "Por favor seleccione un tipo de documento";
        }

        return errors;
    };

    onSubmit = values => {
        const dni = values.tipoDocumento && values.documento ? (values.tipoDocumento + values.documento) : undefined;
        const tipoCliente = values.tipoCliente ? values.tipoCliente.valueOf() : "";
        const filtro: FiltroRecepcionDocumental = {
            dni: dni, 
            tipoCliente: tipoCliente, 
            tamanoPagina: this.props.tamanoPagina,
            paginaActual: 0 
        };

        this.setState({ dni: dni, tipoCliente: tipoCliente });
        this.props.dispatch(consultarAfiliacion(filtro));
    }

    filtros(): FiltroRecepcionDocumental {
        return { tipoCliente: this.state.tipoCliente };
    }

    consultaPaginada = (filtroDocumento: FiltroRecepcionDocumental) => {
        this.props.dispatch(consultarAfiliacion(filtroDocumento));
    };
}

export default connect((store: any) => {
    return {
        estado: R.pathOr([], ["documentos", "estadoRecepcion"])(store),
        mensajeUsuario: R.pathOr([], ["documentos", "mensajeUsuarioRecepcion"])(store),
        afiliaciones: R.pathOr([], ["documentos", "afiliaciones"])(store),
        tamanoPagina: R.pathOr([], ["documentos", "tamanoPagina"])(store),
        paginaActual: R.pathOr([], ["documentos", "paginaActual"])(store),
        paginas: R.pathOr(1, ["documentos", "paginas"])(store)
    };
})(RecepcionDocumental);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/componentes/recepcion/RecepcionDocumental.tsx